// Immagini dei contenuti. I blocchi citano le immagini della libreria come "media:<id>",
// non con un indirizzo, così un contenuto resta valido in ogni ambiente (sviluppo, UAT,
// produzione). Ogni app dice una volta dove sta l'API con setContentMediaBase.

let mediaBase = '';

/** Indirizzo base dell'API (es. https://api.semplora.it); da chiamare all'avvio dell'app. */
export function setContentMediaBase(base: string) {
  mediaBase = base.replace(/\/+$/, '');
}

const MEDIA_REF = /^media:(\d+)$/;

/** Il riferimento a un'immagine della libreria. */
export const mediaRef = (id: number) => `media:${id}`;

/** L'id dell'immagine della libreria, o null se l'indirizzo non è un riferimento. */
export const mediaId = (url?: string | null): number | null => {
  const match = (url ?? '').trim().match(MEDIA_REF);
  return match ? Number(match[1]) : null;
};

/** Indirizzi ammessi per un'immagine: libreria, https e percorsi del sito. */
export const isImageUrl = (url?: string | null) => /^(https?:|\/|media:\d+$)/i.test((url ?? '').trim());

/** L'indirizzo da mettere in <img src>: risolve i riferimenti alla libreria. */
export function resolveImageUrl(url: string): string {
  const id = mediaId(url);
  return id === null ? url.trim() : `${mediaBase}/api/public/content-images/${id}`;
}
